// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"e9277a59","173":"47eaadbf","772":"8cae1022","792":"9cfc35c9","911":"0fd6d27e"}[chunkId] + ".chunk.js";
};